import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { PushMessagesDataService, PushMessagesColumnsService } from '../../../services';
import { PushMessage, PushMessagesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-push-message-details',
  templateUrl: './push-message-details.component.html',
  styleUrls: ['./push-message-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class PushMessageDetailsComponent implements OnInit, OnDestroy {

  public pushMessage: PushMessage = {};
  public pushMessages: PushMessage[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private pushMessagesDataService: PushMessagesDataService,
    private pushMessagesColumnsService: PushMessagesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Push Message - Details');
        this.getPushMessage(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.pushMessage !== 'undefined') {
      this.pushMessage = this.dynamicDialogConfig.data.pushMessage;
    }
    this.columns = this.pushMessagesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getPushMessage(id: number): void {
    this.isLoading = true;
    this.pushMessagesDataService.getPushMessage(id).subscribe((response: PushMessage|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.pushMessage = response;
      }
    });
  }

  list() {
    this.router.navigate(['/push-messages']);
  }

  add() {
    this.router.navigate(['/push-messages/add']);
  }

  edit() {
    this.router.navigate(['/push-messages/edit/' + this.pushMessage.id]);
  }

}
@Component({
  selector: 'app-push-message-details',
  templateUrl: './push-message-details.component.html',
  styleUrls: ['./push-message-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogPushMessageDetailsComponent extends PushMessageDetailsComponent {
}

